<div class="card" data-cy="card">
  <div class="title" data-cy="card-title">{{title}}</div>
  <ul class="list-group" data-cy="list-group">
    @for (item of listGroups; track item; let index = $index) {
      <li
        class="list-group-item" data-cy="list-group-item">
        <span [attr.data-cy]=itemCypressTag(index)>{{item}}</span>
      }
    </ul>
  </div>
